import AssignedTags from '../../common/components/List/AssignedTags/index.js'
import {removeTagFromMOs} from '../../data/moTags.js'
import {hasMOManageTagOnMOPermissionSelector} from '../../data/me.js'
import {useSelector} from '../../store.js'

/**
 *
 * @param {Object} props - The component props.
 * @param {String} props.referenceID - The reference ID of the MO.
 * @param {Array} props.tags - The tags associated with the MO.
 *
 * @returns {React.ReactElement} The rendered component.
 */
export default function MOTags({referenceID, tags}) {
  const hasMOManageTagOnMOPermission = useSelector(
    hasMOManageTagOnMOPermissionSelector,
  )

  return (
    <AssignedTags
      tags={tags}
      hasManageTagOnOrderPermission={hasMOManageTagOnMOPermission}
      onRemove={(tag) => removeTagFromMOs(tag.id, [referenceID])}
    />
  )
}
